export default __webpack_public_path__ + "static/media/walk_step.0b4c2da8.png";